<template>
  <v-container class="grey lighten-5">
    
    <v-card v-if="isErrorParam" flat outlined class="ma-5 pa-3">
      <div class="subtitle-2 mb-2">
        <v-icon class="mr-1" color="primary" small>mdi-information-outline</v-icon>
        <span class="primary--text">分析・診断サービス申し込み情報にアクセスできません</span>
      </div>
      <p class="caption">
        分析・診断サービス申し込み情報にアクセスできません。<br>
        <br>
        すでに削除されている申し込み情報を開こうとしているか、他の事業所の申し込み情報にアクセスしています。<br>
        もう一度お申込みページからアクセスしてください。<br>
      </p>
      <v-btn icon :to="{ path: '/' }">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>お申込みページに戻る
    </v-card>

    <div v-if="!isErrorParam" >
      <v-btn icon :to="{ path: returnPath }">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <span class="display-1 px-3">分析・診断サービス申し込み内容の確認</span>
    </div>
    
    <v-form v-if="!isErrorParam" ref="application_form">

    <v-card flat class="mb-3">
      <v-row dense class="align-end">
        <v-col cols="1" lg="2" md="2" sm="2" xs="1" dense >
          <div class="mx-3 mt-5">
<!--
            <v-chip v-if="application.Status=='受付済み'" color="green" class="white--text">{{ application.Status }}</v-chip>
            <v-chip v-else-if="application.Status=='ご予約中'" color="yellow" class="black--text">{{ application.Status }}</v-chip>
-->
            <v-chip v-bind="getApplicationStatus(this.application.Status,1)" class="mr-2">
            {{getApplicationStatus(this.application.Status,1).text}}</v-chip>
          </div>          
        </v-col>

        <v-col cols="6" dense >
<!--
          <v-tooltip top color="grey" activator="#ordersheet_btn">
            <span>お申込書の印刷画面を開きます。</span>
          </v-tooltip>
          <v-btn 
            small 
            class="mx-3 mt-5"
            rounded 
            color="amber" 
            id="ordersheet_btn"
            :to="{ path: 'ordersheet', query: { id: this.applicationid }}"
            >
            <v-icon class="mr-2">mdi-file</v-icon>
            普通紙（A4）で印刷する
          </v-btn>
-->
          <v-tooltip top color="grey" activator="#ordersheet4ls_btn">
            <span>お申込書の印刷画面を開きます。</span>
          </v-tooltip>
          <v-btn 
            small 
            class="mx-3 mt-5"
            rounded 
            color="amber" 
            id="ordersheet4ls_btn"
            @click="gotoApplication"
            >
            <v-icon class="mr-2">mdi-file</v-icon>
            依頼書を印刷する
          </v-btn>

          <v-btn 
            small 
            class="mx-3 mt-5"
            rounded 
            color="amber" 
            @click="openDeliverablesDialog"
            >
            <v-icon class="mr-2">mdi-download</v-icon>
            納品明細書・報告書ダウンロード
          </v-btn>

<!--
            :to="{ path: 'ordersheet4labelsheet', query: { id: this.applicationid }}"
-->
        </v-col>
      </v-row>
    </v-card>

    <v-card outlined flat class="mb-3">
      <div class="grey darken-3 pa-2 mb-1 white--text">案件情報 <span v-if="application.Name" class="ml-2">[ 注文番号：{{ application.CustomerOrderNumber }} ]</span></div>
      <v-row class="mx-3" dense>
<!--
        <v-col cols="1" dense>案件名</v-col>
        <v-col cols="11" dense>
          <div class="mb-1">{{ application.Name }}</div>
        </v-col>
-->
        <v-col cols="2" dense>お申込み担当者</v-col>
        <v-col cols="10" dense>
          <div class="mb-1">{{ this.application.OrdererCompanyName }} {{ this.application.OrdererOfficeName }} {{ this.application.OrdererName }} 様</div>
        </v-col>

        <v-col cols="2" dense>お申込み日</v-col>
        <v-col cols="10" dense>
          <div class="mb-1">{{ application.createdAt| moment('YYYY[年]MM[月]DD[日] HH[時]mm[分]') }}</div>
        </v-col>

        <v-col cols="2" dense>ご注文番号</v-col>
        <v-col cols="10" dense>
          <div class="mb-1">{{ application.CustomerOrderNumber }}</div>
        </v-col>

        <v-col cols="2" dense>ご予約番号</v-col>
        <v-col cols="10" dense>
          <div class="mb-1">{{ application.id }}</div>
        </v-col>

        <v-col v-if="application.QuoteNumber" cols="2" dense>お見積り番号</v-col>
        <v-col v-if="application.QuoteNumber" cols="10" dense>
          <div class="mb-1">{{ application.QuoteNumber }}
          <v-btn 
            x-small 
            class="my-0 ml-5"
            rounded 
            color="amber" 
            :to="{ path: 'quotesheet', query: { id: this.application.QuoteNumber, appid: this.application.id}}"
            >
            <v-icon class="mr-2" small>mdi-file</v-icon>
            お見積りを見る
          </v-btn>
          </div>
        </v-col>

        <v-col cols="2" dense>受注番号</v-col>
        <v-col cols="10" dense>
          <div class="mb-1" v-show="application.OrderNumber">{{ application.OrderNumber }}</div>
          <div class="mb-1" v-show="!application.OrderNumber">採番待ち</div>
        </v-col>

        <v-col cols="2" dense>分析依頼料金</v-col>
        <v-col cols="10" dense>
          <div class="mb-1">&yen; {{ (AnalizeFee + SurplusFee).toLocaleString() }}
            <span v-if="SurplusCount > 0" class="">
              （税抜き サンプル返却手数料
              {{SurplusFee.toLocaleString()}} 円含む）
            </span>
            <span v-else class="">
              （税抜き）
            </span>
          </div>
          <div v-if="DiscountInfo.code" class="red--text">
            Web割引
            - {{Number(DiscountInfo.discount).toLocaleString()}} 円
          </div>
        </v-col>
      </v-row>
    </v-card>

    <v-card outlined flat class="mb-3">
      <div class="grey darken-3 pa-2 mb-1 white--text">納品明細書の送付先</div>
      <v-row class="mx-3" dense>
        <v-col cols="2" dense>ご住所</v-col>
        <v-col cols="10" dense>
          <div class="mb-1">{{ payOffice.Zip }} {{ payOffice.Address1 }} {{ payOffice.Address2 }} {{ payOffice.Address3 }}</div>
        </v-col>
      </v-row>
      <v-row class="mx-3" dense>
        <v-col cols="2" dense>宛名</v-col>
        <v-col cols="10" dense>
          <div class="mb-1">{{ application.PayCompany }} {{ application.PayOffice }}</div>
          <div class="mb-1">{{ application.PayDept }}</div>
          <div class="mb-1" v-if=(application.PayPIC)>{{ application.PayPIC }} 様</div>
        </v-col>
      </v-row>
      <v-row class="mx-3" dense>
        <v-col cols="2" dense>お電話番号</v-col>
        <v-col cols="10" dense>
          <div class="mb-1">{{ payOffice.Tel }}</div>
        </v-col>
      </v-row>
      <v-row class="mx-3" dense>
        <v-col cols="2" dense>FAX番号</v-col>
        <v-col cols="10" dense>
          <div class="mb-1">{{ payOffice.FAX }}</div>
        </v-col>
      </v-row>
      <v-row class="mx-3" dense>
        <v-col cols="2" dense>メールアドレス</v-col>
        <v-col cols="10" dense>
          <div class="mb-1" v-if=(payEmployee)>{{ payEmployee.email }}</div>
        </v-col>
      </v-row>
      <v-row class="mx-3" dense>
        <v-col cols="2" dense>送付方法</v-col>
        <v-col cols="10" dense>
          <div class="mb-1">{{ application.Shipping }}</div>
        </v-col>
      </v-row>
    </v-card>

    <v-card outlined flat class="mb-3">
      <div class="grey darken-3 pa-2 mb-1 white--text">報告書の送付先</div>
      <v-row class="mx-3" dense>
        <v-col cols="2" dense>ご住所</v-col>
        <v-col cols="10" dense>
          <div class="mb-1">{{ delvOffice.Zip }} {{ delvOffice.Address1 }} {{ delvOffice.Address2 }} {{ delvOffice.Address3 }}</div>
        </v-col>
      </v-row>
      <v-row class="mx-3" dense>
        <v-col cols="2" dense>宛名</v-col>
        <v-col cols="10" dense>
          <div class="mb-1">{{ application.DelvCompany }} {{ application.DelvOffice }}</div>
          <div class="mb-1">{{ application.DelvDept }}</div>
          <div class="mb-1" v-if=(application.DelvPIC)>{{ application.DelvPIC }} 様</div>
        </v-col>
      </v-row>
      <v-row class="mx-3" dense>
        <v-col cols="2" dense>お電話番号</v-col>
        <v-col cols="10" dense>
          <div class="mb-1">{{ delvOffice.Tel }}</div>
        </v-col>
      </v-row>
      <v-row class="mx-3" dense>
        <v-col cols="2" dense>FAX番号</v-col>
        <v-col cols="10" dense>
          <div class="mb-1">{{ delvOffice.FAX }}</div>
        </v-col>
      </v-row>
      <v-row class="mx-3" dense>
        <v-col cols="2" dense>メールアドレス</v-col>
        <v-col cols="10" dense>
          <div class="mb-1" v-if=(delvEmployee)>{{ delvEmployee.email }}</div>
        </v-col>
      </v-row>
    </v-card>

    <v-card outlined flat class="mb-3">
      <div class="grey darken-3 pa-2 mb-1 white--text">報告書の宛名（報告書に記載するお名前）</div>
      <v-row class="mx-3" dense>
        <v-col cols="2" dense>宛名</v-col>
        <v-col cols="10" dense>
          <div class="mb-1">{{ application.RepCompany }} {{ application.RepOffice }}</div>
          <div class="mb-1">{{ application.RepDept }}</div>
          <div class="mb-1" v-if=(application.RepPIC)>{{ application.RepPIC }} 様</div>
        </v-col>
      </v-row>
    </v-card>
<!--
    <v-card outlined flat class="mb-3">
      <div class="grey darken-3 pa-2 mb-1 white--text">納品明細書の送付先</div>
      <v-row class="mx-3" dense>
        <v-col cols="2" dense>ご住所</v-col>
        <v-col cols="10" dense>
          <div class="mb-1">{{ payOffice.Zip }} {{ payOffice.Address1 }} {{ payOffice.Address2 }} {{ payOffice.Address3 }}</div>
        </v-col>
        <v-col cols="2" dense>宛名</v-col>
        <v-col cols="10" dense>
          <div class="mb-1">{{ application.PayCompany }} {{ application.PayOffice }}</div>
          <div class="mb-1">{{ application.PayDept }}</div>
          <div class="mb-1" v-if=(application.PayPIC)>{{ application.PayPIC }} 様</div>
        </v-col>
        <v-col cols="2" dense>お電話番号</v-col>
        <v-col cols="10" dense>
          <div class="mb-1">{{ payOffice.Tel }}</div>
        </v-col>
        <v-col cols="2" dense>FAX番号</v-col>
        <v-col cols="10" dense>
          <div class="mb-1">{{ payOffice.FAX }}</div>
        </v-col>
      </v-row>
    </v-card>
-->
    <v-card outlined flat class="mb-3">
      <div class="grey darken-3 pa-2 mb-1 white--text">分析サンプル（{{ application.SampleCount }} サンプル）</div>
      <v-row dense>
        <v-col>
          <div class="pa-2">
            <span class="caption ml-2">分析を依頼したサンプル情報の一覧です。クリックするとサンプル情報の詳細を確認できます。</span>
          </div>
          <v-data-table
            :headers="headers"
            :items="samples"
            :page.sync="page"
            :items-per-page="itemsPerPage"
            :search="search"
            :loading="loading"
              :sort-by="['SampleID']"
              :sort-desc="[false]"
            loading-text="読込中"
            no-data-text="データがありません。"          
            class="elevation-1"
            hide-default-footer
            @page-count="pageCount = $event"
            @click:row="(data) => { SampleMordal(data) }"   
            id="row-pointer"
          >
          <!-- <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">{{ item.AnalizeItemName }}</td>
          </template>         -->
          <template v-slot:[`item.SampleID`]="{ item }">
            <span > {{ numSampleID(item.SampleID) }} </span>
          </template>
<!--
          <template v-slot:[`item.Price`]="{ item }">
            <span > &yen; {{ Number(item.Price).toLocaleString() }} </span>
          </template>
-->
          <template v-slot:[`item.Fee`]="{ item }">
            <span v-if="item.Fee"> &yen; {{ Number(item.Fee).toLocaleString() }} </span>
            <span v-else> &yen; {{ Number(item.Price).toLocaleString() }} </span>
          </template>
          <template v-slot:[`item.Quantity`]="{ item }">
            <span> {{ item.Quantity }} mL</span>
          </template>
          <template v-slot:[`item.DeliveryPeriod`]="{ item }">
            <span v-show="item.DeliveryPeriod">{{ item.DeliveryPeriod }} </span>
            <span v-show="!item.DeliveryPeriod">指定無し</span>
          </template>
          <template v-slot:[`item.AnalizeSetName`]="{ item }">
            <span v-show="item.AnalizeSetName">{{ item.AnalizeSetName }} </span>
            <span v-show="!item.AnalizeSetName">指定無し</span>
          </template>
        </v-data-table>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="10"  lg="10" md='8' sm='8' xs="10">
          <v-pagination v-model="page" color="amber black--text" light circle :length="pageCount"></v-pagination>
        </v-col>
        <v-col cols="2"  lg="2"  md='4' sm='4' xs="2">
          <v-select
            :value="itemsPerPage"
            :items = "itemsPerPageList"
            label="1ページの行数"
            @input="itemsPerPage = $event"
          ></v-select>
        </v-col>
      </v-row>
    </v-card>

    </v-form>

    <v-dialog v-model="isDeliverablesDialog" max-width="80%">
      <v-card>
        <v-card-title class="headline grey lighten-2">
          <span class="ml-2">納品明細書・報告書ダウンロード</span>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="deliverablesHeaders"
            :items="deliverables"
            :page.sync="deliverablesPage"
            :items-per-page="deliverablesItemsPerPage"
            :loading="deliverablesLoading"
            loading-text="読込中"
            no-data-text="データがありません。"
            class="elevation-1 mt-3"
            hide-default-footer
            @page-count="deliverablesPageCount = $event"
            @click:row="showDeliverableDetail"
            id="row-pointer"
          >
            <template v-slot:[`item.Type`]="{ item }">
              <v-chip small :color="getTypeColor(item.Type)" class="white--text">
                {{ item.Type }}
              </v-chip>
            </template>
            <template v-slot:[`item.Status`]="{ item }">
              <v-chip small :color="getStatusColor(item.Status)" class="white--text">
                {{ getStatusText(item.Status) }}
              </v-chip>
            </template>
            <template v-slot:[`item.FileName`]="{ item }">
              {{ getFileNameOnly(item.FileName) }}
            </template>
            <template v-slot:[`item.createdAt`]="{ item }">
              {{ item.createdAt | moment('YYYY[年]MM[月]DD[日]') }}
            </template>
            <template v-slot:[`item.DownloadDeadline`]="{ item }">
              {{ item.DownloadDeadline | moment('YYYY[年]MM[月]DD[日]') }}
            </template>
          </v-data-table>
          <v-row dense class="mt-3">
            <v-col cols="10" lg="10" md='8' sm='8' xs="10">
              <v-pagination
                v-model="deliverablesPage"
                :length="deliverablesPageCount"
                color="amber black--text"
                light
                circle
              ></v-pagination>
            </v-col>
            <v-col cols="2" lg="2" md='4' sm='4' xs="2">
              <v-select
                :value="deliverablesItemsPerPage"
                :items="deliverablesItemsPerPageList"
                label="1ページの行数"
                @input="deliverablesItemsPerPage = $event"
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="amber darken-1" rounded @click="isDeliverablesDialog=false" class="ma-4">閉じる</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="isDeliverableDetailDialog" max-width="70%">
      <v-card>
        <v-card-title class="headline grey lighten-2">
          <span class="ml-2">納品明細書・報告書詳細<span v-if="selectedDeliverable" class="body-2">（{{ selectedDeliverable.id }}）</span></span>
        </v-card-title>
        <v-card-text v-if="selectedDeliverable">
          <v-row dense>
            <v-col cols="3">
              <span class="caption">タイプ</span><br>
              <v-chip small :color="getTypeColor(selectedDeliverable.Type)" class="white--text">
                {{ selectedDeliverable.Type }}
              </v-chip>
            </v-col>
            <v-col cols="3">
              <span class="caption">ステータス</span><br>
              <v-chip small :color="getStatusColor(selectedDeliverable.Status)" class="white--text">
                {{ getStatusText(selectedDeliverable.Status) }}
              </v-chip>
            </v-col>
            <v-col cols="6">
              <span class="caption">ダウンロード期限</span><br>
              <span class="body-1">{{ selectedDeliverable.DownloadDeadline | moment('YYYY[年]MM[月]DD[日]') }}</span>
            </v-col>
          </v-row>
          <v-divider class="my-3"></v-divider>
          <v-row dense  v-if="selectedDeliverable.Type==='報告書' || selectedDeliverable.Type==='報告書その他'">
            <v-col cols="6">
              <span class="caption">サンプル名</span><br>
              <span class="body-1">{{ selectedDeliverable.SampleName || '-' }}</span>
            </v-col>
            <v-col cols="6">
              <span class="caption">サンプルID</span><br>
              <span class="body-1">{{ selectedDeliverable.SampleID || '-' }}</span>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="6">
              <span class="caption">受注番号</span><br>
              <span class="body-1">{{ selectedDeliverable.OrderNumber }}</span>
            </v-col>
            <v-col cols="6" v-if="selectedDeliverable.Type==='報告書' || selectedDeliverable.Type==='報告書その他'">
              <span class="caption">依頼番号</span><br>
              <span class="body-1">{{ selectedDeliverable.SampleNumber }}</span>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="6">
              <span class="caption">ファイル名</span><br>
              <span class="body-1">{{ getFileNameOnly(selectedDeliverable.FileName) }}</span>
            </v-col>
            <v-col cols="6" v-if="selectedDeliverable.Type==='報告書'">
              <span class="caption">報告書番号</span><br>
              <span class="body-1">{{ getFileNameOnly(selectedDeliverable.ReportNumber) }}({{ getFileNameOnly(selectedDeliverable.ReportVersion) }})</span>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="6">
              <span class="caption">ダウンロード回数</span><br>
              <span class="body-1">{{ selectedDeliverable.DownloadCount }}回</span>
            </v-col>
          </v-row>

        </v-card-text>
        <v-card-actions>
          <div>
            <v-btn 
              color="amber" 
              rounded 
              @click="downloadFile" 
              class="ma-4"
              :disabled="isDownloadExpired"
            >
              <v-icon class="mr-2">mdi-download</v-icon>
              ダウンロード
            </v-btn>
            <div v-if="isDownloadExpired" class="red--text caption ml-4">
              ダウンロード期限を過ぎています
            </div>
          </div>
          <v-spacer></v-spacer>
          <v-btn color="amber darken-1" rounded @click="isDeliverableDetailDialog=false" class="ma-4">閉じる</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="isSampleDeliverablesDialog" max-width="80%">
      <v-card>
        <v-card-title class="headline grey lighten-2">
          <span class="ml-2">報告書一覧</span>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="deliverablesHeaders"
            :items="sampleDeliverables"
            :page.sync="sampleDeliverablesPage"
            :items-per-page="sampleDeliverablesItemsPerPage"
            :loading="sampleDeliverablesLoading"
            loading-text="読込中"
            no-data-text="データがありません。"
            class="elevation-1 mt-3"
            hide-default-footer
            @page-count="sampleDeliverablesPageCount = $event"
            @click:row="showSampleDeliverableDetail"
            id="row-pointer"
          >
            <template v-slot:[`item.Type`]="{ item }">
              <v-chip small :color="getTypeColor(item.Type)" class="white--text">
                {{ item.Type }}
              </v-chip>
            </template>
            <template v-slot:[`item.Status`]="{ item }">
              <v-chip small :color="getStatusColor(item.Status)" class="white--text">
                {{ getStatusText(item.Status) }}
              </v-chip>
            </template>
            <template v-slot:[`item.FileName`]="{ item }">
              {{ getFileNameOnly(item.FileName) }}
            </template>
            <template v-slot:[`item.createdAt`]="{ item }">
              {{ item.createdAt | moment('YYYY[年]MM[月]DD[日]') }}
            </template>
            <template v-slot:[`item.DownloadDeadline`]="{ item }">
              {{ item.DownloadDeadline | moment('YYYY[年]MM[月]DD[日]') }}
            </template>
          </v-data-table>
          <v-row dense class="mt-3">
            <v-col cols="10" lg="10" md='8' sm='8' xs="10">
              <v-pagination
                v-model="sampleDeliverablesPage"
                :length="sampleDeliverablesPageCount"
                color="amber black--text"
                light
                circle
              ></v-pagination>
            </v-col>
            <v-col cols="2" lg="2" md='4' sm='4' xs="2">
              <v-select
                :value="sampleDeliverablesItemsPerPage"
                :items="sampleDeliverablesItemsPerPageList"
                label="1ページの行数"
                @input="sampleDeliverablesItemsPerPage = $event"
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="amber darken-1" rounded @click="isSampleDeliverablesDialog=false" class="ma-4">閉じる</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="isSampleDeliverableDetailDialog" max-width="70%">
      <v-card>
        <v-card-title class="headline grey lighten-2">
          <span class="ml-2">報告書詳細<span v-if="selectedSampleDeliverable" class="body-2">（{{ selectedSampleDeliverable.id }}）</span></span>
        </v-card-title>
        <v-card-text v-if="selectedSampleDeliverable">
          <v-row dense>
            <v-col cols="3">
              <span class="caption">タイプ</span><br>
              <v-chip small :color="getTypeColor(selectedSampleDeliverable.Type)" class="white--text">
                {{ selectedSampleDeliverable.Type }}
              </v-chip>
            </v-col>
            <v-col cols="3">
              <span class="caption">ステータス</span><br>
              <v-chip small :color="getStatusColor(selectedSampleDeliverable.Status)" class="white--text">
                {{ getStatusText(selectedSampleDeliverable.Status) }}
              </v-chip>
            </v-col>
            <v-col cols="6">
              <span class="caption">ダウンロード期限</span><br>
              <span class="body-1">{{ selectedSampleDeliverable.DownloadDeadline | moment('YYYY[年]MM[月]DD[日]') }}</span>
            </v-col>
          </v-row>
          <v-divider class="my-3"></v-divider>
          <v-row dense  v-if="selectedSampleDeliverable.Type==='報告書' || selectedSampleDeliverable.Type==='報告書その他'">
            <v-col cols="6">
              <span class="caption">サンプル名</span><br>
              <span class="body-1">{{ selectedSampleDeliverable.SampleName || '-' }}</span>
            </v-col>
            <v-col cols="6">
              <span class="caption">サンプルID</span><br>
              <span class="body-1">{{ selectedSampleDeliverable.SampleID || '-' }}</span>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="6">
              <span class="caption">受注番号</span><br>
              <span class="body-1">{{ selectedSampleDeliverable.OrderNumber }}</span>
            </v-col>
            <v-col cols="6"  v-if="selectedSampleDeliverable.Type==='報告書' || selectedSampleDeliverable.Type==='報告書その他'">
              <span class="caption">依頼番号</span><br>
              <span class="body-1">{{ selectedSampleDeliverable.SampleNumber }}</span>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="6">
              <span class="caption">ファイル名</span><br>
              <span class="body-1">{{ getFileNameOnly(selectedSampleDeliverable.FileName) }}</span>
            </v-col>
            <v-col cols="6" v-if="selectedSampleDeliverable.Type==='報告書'">
              <span class="caption">報告書番号</span><br>
              <span class="body-1">{{ getFileNameOnly(selectedSampleDeliverable.ReportNumber) }}({{ getFileNameOnly(selectedSampleDeliverable.ReportVersion) }})</span>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="6">
              <span class="caption">ダウンロード回数</span><br>
              <span class="body-1">{{ selectedSampleDeliverable.DownloadCount }}回</span>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <div>
            <v-btn 
              color="amber" 
              rounded 
              @click="downloadSampleFile" 
              class="ma-4"
              :disabled="isSampleDownloadExpired"
            >
              <v-icon class="mr-2">mdi-download</v-icon>
              ダウンロード
            </v-btn>
            <div v-if="isSampleDownloadExpired" class="red--text caption ml-4">
              ダウンロード期限を過ぎています
            </div>
          </div>
          <v-spacer></v-spacer>
          <v-btn color="amber darken-1" rounded @click="isSampleDeliverableDetailDialog=false" class="ma-4">閉じる</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="isSampleMordal" max-width="90%">
      <v-card>
        <v-card-title primary-title class="headline grey lighten-2">
          <!-- <span class="headline">分析サンプル詳細</span> -->
          <span class="ml-2 caption">サンプル詳細:</span>
          <span class="ml-3 body-1">[{{ numSampleID(data.SampleID) }}] {{ data.Name }} （Webサンプル登録番号：{{ data.id }}）</span>
       </v-card-title>
        <v-card-text>
        <v-chip small label outlined class="mt-3">機器・オイル情報</v-chip>          
        <v-row dense>
          <v-col cols="3">
            <span class="ml-2 caption">{{getItemName('マイ機器ＩＤ')[AnalizeTypeCategory+'label']}}</span>
            <span class=".d-flex .d-sm-none"><br></span>
            <span class="ml-3 body-1">{{ data.CustomerMachineID }}</span>
          </v-col>
          <v-col cols="3">
            <span class="ml-2 caption">{{getItemName('累計使用時間／距離')[AnalizeTypeCategory+'label']}}</span>
            <span class=".d-flex .d-sm-none"><br></span>
            <span class="ml-3 body-1">{{ data.TotalOperatingTime }} {{ data.TotalOperatingTimeUnitText }}</span>
          </v-col>
          <v-col cols="3">
<!--
            <span class="ml-2 caption">前回分析診断からの使用時間／距離</span>
            <span class=".d-flex .d-sm-none"><br></span>
            <span class="ml-3 body-1">{{ data.OperatingTime }} {{ data.OperatingTimeUnitText }}</span>
-->
          </v-col>
          <v-col cols="3">
          </v-col>
          <v-col cols="3">
            <span class="ml-2 caption">{{getItemName('使用オイルメーカー')[AnalizeTypeCategory+'label']}}</span>
            <span class=".d-flex .d-sm-none"><br></span>
            <span class="ml-3 body-1">{{ data.OilmakerID }}</span>
          </v-col>
          <v-col cols="3">
            <span class="ml-2 caption">{{getItemName('使用オイル銘柄')[AnalizeTypeCategory+'label']}}</span>
            <span class=".d-flex .d-sm-none"><br></span>
            <span class="ml-3 body-1">{{ data.OilModelNumber }}</span>
          </v-col>
          <v-col cols="3">
            <span class="ml-2 caption">{{getItemName('オイルの種類')[AnalizeTypeCategory+'label']}}</span>
            <span class=".d-flex .d-sm-none"><br></span>
            <span class="ml-3 body-1">{{ data.OilTypeCategoryText }}（{{ data.OilTypeText }}）</span>
          </v-col>
          <v-col cols="3">
            <span class="ml-2 caption">{{getItemName('オイル使用時間')[AnalizeTypeCategory+'label']}}</span>
            <span class=".d-flex .d-sm-none"><br></span>
            <span class="ml-3 body-1">{{ data.OilUsageTime }} {{ data.OilUsageTimeUnitText }}</span>
          </v-col>



        </v-row>
          <v-divider></v-divider>
          <v-chip small label outlined class="mt-3">分析情報</v-chip>          
        <v-row dense>
          <v-col cols="3">
            <span class="ml-2 caption">分析方法</span>
            <span class=".d-flex .d-sm-none"><br></span>
            <span class="ml-3 body-1">{{ data.AnalizeTypeGroup }}</span>
          </v-col>
          <v-col cols="3">
            <span class="ml-2 caption">分析区分</span>
            <span class=".d-flex .d-sm-none"><br></span>
            <span class="ml-3 body-1">{{ data.AnalizeTypeName }}</span>
          </v-col>
          <v-col cols="3" v-show="data.StandardValue">
            <span class="ml-2 caption">分析規格(報告書に記載します)</span>
            <span class=".d-flex .d-sm-none"><br></span>
            <span v-show="data.StandardValue" class="ml-3 body-2">{{ data.StandardValueName }}</span>
            <span v-show="!data.StandardValue" class="ml-3 body-2">指定無し</span>
          </v-col>
          <v-col cols="3">
            <span class="ml-2 caption">セット分析</span>
            <span class=".d-flex .d-sm-none"><br></span>
            <span v-show="data.AnalizeSetName" class="ml-3 body-2">{{ data.AnalizeSetName }}</span>
            <span v-show="!data.AnalizeSetName" class="ml-3 body-2">指定無し</span>
          </v-col>
          <v-col cols="12">
            <span class="ml-2 caption">分析項目</span>
            <span class=".d-flex .d-sm-none"><br></span>
<!--
                  <span v-for="item of data.AnalizeItemNames" v-bind:key="item.name">
                    <v-chip
                      color="green darken-3"
                      text-color="white"
                      class="mr-2"
                    >
                      {{ item.name }}
                    </v-chip>
                  </span>
-->
                  <template v-for="(item, index) in data.AnalizeItemNames">
                    <v-chip small color="green" class="white--text ml-2 mb-1" :key="index"> {{item}}</v-chip>
                  </template>
          
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-chip small class="mt-3" label outlined>採取情報</v-chip>          
        <v-row dense>
          <v-col cols="3">
            <span class="ml-2 caption">{{getItemName('採取日')[AnalizeTypeCategory+'label']}}</span>
            <span class=".d-flex .d-sm-none"><br></span>
            <span class="ml-3 body-1">{{ data.SamplingAt }}</span>
          </v-col>
          <v-col cols="3">
            <span class="ml-2 caption">{{getItemName('ボトル数')[AnalizeTypeCategory+'label']}}</span>
            <span class=".d-flex .d-sm-none"><br></span>
            <span class="ml-3 body-1"> {{ data.BottleCount }}</span>
          </v-col>
          <v-col cols="3">
            <span class="ml-2 caption">{{getItemName('必要オイル量')[AnalizeTypeCategory+'label']}}</span>
            <span class=".d-flex .d-sm-none"><br></span>
            <span class="ml-3 body-1">{{ data.Quantity }} mL</span>
          </v-col>
          <v-col cols="12">
            <span class="ml-2 caption">{{getItemName('サンプルメモ')[AnalizeTypeCategory+'label']}}</span>
            <span class=".d-flex .d-sm-none"><br></span>
            <v-textarea v-show="data.Memo" v-model="data.Memo" dense filled readonly></v-textarea>
            <!-- <span v-show="data.memo" class="ml-3 body-1">{{ data.memo }}</span> -->
            <span v-show="!data.Memo" class="ml-3 body-1">メモなし</span>

          </v-col>
        </v-row>
          <v-divider></v-divider>
          <v-chip small label outlined class="mt-3">依頼情報</v-chip>          
        <v-row dense>
          <v-col cols="3">
            <span class="ml-2 caption">分析料金</span>
            <span class=".d-flex .d-sm-none"><br></span>
            <span class="ml-3 body-1">&yen; {{ Number(data.Price).toLocaleString() }}</span>
          </v-col>
          <v-col cols="3">
<!--
            <span class="ml-2 caption">指定納期</span>
            <span class=".d-flex .d-sm-none"><br></span>
            <span v-show="data.DeliveryPeriod" class="ml-3 body-2">{{ data.DeliveryPeriod }}</span>
            <span v-show="!data.DeliveryPeriod" class="ml-3 body-2">指定無し</span>
-->
          </v-col>
          <v-col cols="3">
            <span class="ml-2 caption">フィルター返却</span>
            <span class=".d-flex .d-sm-none"><br></span>
            <span v-if="data.Filter === '001'" class="ml-3 body-1">不要</span>
            <span v-if="data.Filter === '002'" class="ml-3 body-1">ラミネート加工あり</span>
            <span v-if="data.Filter === '003'" class="ml-3 body-1">ラミネート加工なし</span>
          </v-col>
          <v-col cols="3">
            <span class="ml-2 caption">サンプル返却</span>
            <span class=".d-flex .d-sm-none"><br></span>
            <span v-if="data.Surplus === '0'" class="ml-3 body-1">不要</span>
            <span v-if="data.Surplus === '1'" class="ml-3 body-1">必要</span>
          </v-col>
        </v-row>
       
        </v-card-text>

        <v-card-actions>
          <v-btn color="amber" rounded @click="openSampleDeliverablesDialog" class="ma-4">
            <v-icon class="mr-2">mdi-download</v-icon>
            報告書ダウンロード
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="amber darken-1" rounded @click="isSampleMordal=false" class="ma-4">閉じる</v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>


  </v-container>
</template>

<script>
import { API, graphqlOperation, Storage } from "aws-amplify"
import { getApplication, samplesByApplication, deliverablesByApplication, deliverablesBySample } from '../graphql/queries'
import { createDownLoadHistory, updateDeliverables } from '../graphql/mutations'
import { officeByKey } from '../graphql/queries'
import { employeeByKey } from '../graphql/queries'
import utils  from '../utils/utils.js'
import mixin  from '../utils/mixin.js'

export default {
  mixins:[utils, mixin],
  components:{
  },
  head: {
    title: { inner: '分析・診断サービス依頼参照'},
  },
    data: () => ({
        applicationid: "",
        application: {},
        delvOffice: {},
        payOffice: {},
        delvEmployee: {},
        payEmployee: {},
        samples: [],
        search: '',
        page: 1,
        pageCount: 0,
        itemsPerPage: 5,
        itemsPerPageList: [ 5,10,30 ],
        AnalizeSetName: '',
        AnalizeSet: '',
        loading: false,
        overlayStepper1: true,
        isSampleMordal: false,
        isErrorParam: false,
        ErrorInfo: "",
        AnalizeFee: 0,
        DiscountInfo: {},
        SurplusFee:0,
        SurplusCount:0,

        AnalizeTypeCategory: "",

        isDeliverablesDialog: false,
        deliverables: [],
        deliverablesLoading: false,
        deliverablesPage: 1,
        deliverablesPageCount: 0,
        deliverablesItemsPerPage: 5,
        deliverablesItemsPerPageList: [5, 10, 30],
        isDeliverableDetailDialog: false,
        selectedDeliverable: null,
        isSampleDeliverablesDialog: false,
        sampleDeliverables: [],
        sampleDeliverablesLoading: false,
        sampleDeliverablesPage: 1,
        sampleDeliverablesPageCount: 0,
        sampleDeliverablesItemsPerPage: 5,
        sampleDeliverablesItemsPerPageList: [5, 10, 30],
        isSampleDeliverableDetailDialog: false,
        selectedSampleDeliverable: null,
        deliverablesHeaders: [
          {
            text: 'タイプ',
            value: 'Type',
            class: "grey darken-2 white--text",
            width: '15%'
          },
          {
            text: 'サンプル名',
            value: 'SampleName',
            class: "grey darken-2 white--text",
            width: '25%'
          },
          {
            text: 'ファイル名',
            value: 'FileName',
            class: "grey darken-2 white--text",
            width: '25%'
          },
          {
            text: '登録日',
            value: 'createdAt',
            class: "grey darken-2 white--text",
            width: '15%'
          },
          {
            text: 'ダウンロード期限',
            value: 'DownloadDeadline',
            class: "grey darken-2 white--text",
            width: '20%'
          }
        ],

        data: {
            AnalizeItemNames:[],
        },
//        data: {},
        headers: [
            {
            text: 'サンプル',
            align: 'start',
            value: 'SampleID',
            class: "grey darken-2 white--text",
            width: '5%'
            },            {
            text: 'サンプル名',
            align: 'start',
            value: 'Name',
            class: "grey darken-2 white--text",
            width: '20%'
            },
            {
            text: '機器ＩＤ',
            value: 'CustomerMachineID',
            class: "grey darken-2 white--text",
            width: '20%'
            },
            {
            text: '採取日',
            class: "grey darken-2 white--text",
            value: 'SamplingAt'
            },
            {
            text: '分析区分',
            class: "grey darken-2 white--text",
            value: 'AnalizeTypeName',
            sortable: false,
            },
            {
            text: 'セット分析',
            class: "grey darken-2 white--text",
            value: 'AnalizeSetName',
            sortable: false,
            },
            {
            text: '分析料金',
            class: "grey darken-2 white--text",
//            value: 'Price'
            value: 'Fee'
            },
            {
            text: 'サンプル量',
            class: "grey darken-2 white--text",
            value: 'Quantity',
            sortable: false,
            },
/*
            {
            text: '指定納期',
            class: "grey darken-2 white--text",
            value: 'DeliveryPeriod',
            sortable: false,
            },
*/
            // {
            // text: '分析項目',
            // value: 'data-table-expand'
            // },
        ],
    }),
    computed: {
      isSystemAdmin : function() {
        return this.$store.state.isSystemAdmin
      },
      returnPath() {
        if(this.$store.state.isStaff == true) {
          return "/staffpage"
        }else {
          return "/"
        }
      },
      isDownloadExpired() {
        if (!this.selectedDeliverable || !this.selectedDeliverable.DownloadDeadline) {
          return false
        }
        const deadline = new Date(this.selectedDeliverable.DownloadDeadline)
        const now = new Date()
        return now > deadline
      },
      isSampleDownloadExpired() {
        if (!this.selectedSampleDeliverable || !this.selectedSampleDeliverable.DownloadDeadline) {
          return false
        }
        const deadline = new Date(this.selectedSampleDeliverable.DownloadDeadline)
        const now = new Date()
        return now > deadline
      }
    },
    methods: {
      SampleMordal: async function(data) {
        console.log('data', data)
        this.isSampleMordal = true  
        this.data = data      
      },

      gotoApplication: function() {
        // 得意先.依頼区分が一般の場合はマイ機器作成（一般、装備・装置）
        if(this.AnalizeTypeCategory == "一般") {
          this.$router.push("/ordersheet4labelsheet?id=" + this.applicationid)
        // 得意先.依頼区分が航空機の場合、登録マイ機器の種別選択画面
        }else {
          this.$router.push("/ordersheet4labelsheetJET?id=" + this.applicationid)
        }
      },

      numSampleID (sampleid) {
        return ( '000' + Number(sampleid) ).slice( -3 );
      },

      openDeliverablesDialog: async function() {
        this.isDeliverablesDialog = true
        this.deliverablesLoading = true
        
        try {
          const result = await API.graphql(graphqlOperation(deliverablesByApplication, {
            ApplicationID: this.applicationid
          }))
          this.deliverables = result.data.deliverablesByApplication.items.filter(item => item.Status === 'READY')
        } catch (err) {
          console.log('Error fetching deliverables:', err)
        }
        
        this.deliverablesLoading = false
      },

      getTypeColor(type) {
        switch(type) {
          case '納品書': return 'blue'
          case '納品書その他': return 'blue'
          case '報告書': return 'green'
          case '報告書その他': return 'green'
          case '速報報告書': return 'orange'
          default: return 'grey'
        }
      },

      getStatusColor(status) {
        switch(status) {
          case 'READY': return 'green'
          case 'PENDING': return 'orange'
          case 'STOP': return 'red'
          default: return 'grey'
        }
      },

      getStatusText(status) {
        switch(status) {
          case 'READY': return 'ダウンロード可'
          case 'PENDING': return 'ダウンロード準備中'
          case 'STOP': return 'ダウンロード不可'
          default: return status
        }
      },

      getFileNameOnly(filePath) {
        if (!filePath) return ''
        return filePath.split('/').pop()
      },

      showDeliverableDetail(item) {
        this.selectedDeliverable = item
        this.isDeliverableDetailDialog = true
      },

      downloadDeliverableFile: async function(deliverable) {
        if (!deliverable || !deliverable.FileName) {
          console.error('No file selected for download')
          return
        }

        try {
          const filePath = 'deliverable' + deliverable.FileName
          
          const signedURL = await Storage.get(filePath, {
            level: 'public',
            expires: 60,
            contentType: 'application/octet-stream'
          })
          
          const link = document.createElement('a')
          link.href = signedURL
          link.download = this.getFileNameOnly(deliverable.FileName)
          link.target = '_blank'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          
          // システム管理者以外がダウンロードした場合のみ、ダウンロード履歴を記録
          if(!this.isSystemAdmin) {
            const currentDateTime = new Date().toISOString()
            const currentUser = this.$store.state.employee?.Name || 'unknown'
            
            // Deliverablesレコードを更新
            const updateInput = {
              id: deliverable.id,
              DownloadCount: (deliverable.DownloadCount || 0) + 1
            }
            
            // 初回ダウンロードの場合はDownloadAtとDownloadUserも更新
            if (!deliverable.DownloadAt) {
              updateInput.DownloadAt = currentDateTime
              updateInput.DownloadUser = currentUser
            }
            
            await API.graphql(graphqlOperation(updateDeliverables, {
              input: updateInput
            }))
            
            // DownLoadHistoryレコードを作成
            const downloadHistory = {
              DeliverablesID: deliverable.id,
              DownloadAt: currentDateTime,
              DownloadUser: currentUser,
              Type: 'WEB_DOWNLOAD'
            }
            
            await API.graphql(graphqlOperation(createDownLoadHistory, {
              input: downloadHistory
            }))
            console.log('File download initiated successfully')
          }
        } catch (err) {
          console.error('Error downloading file:', err)
        }
      },

      downloadFile: async function() {
        await this.downloadDeliverableFile(this.selectedDeliverable)
      },

      openSampleDeliverablesDialog: async function() {
        if (!this.data || !this.data.id) {
          console.error('No sample selected')
          return
        }
        
        this.isSampleDeliverablesDialog = true
        this.sampleDeliverablesLoading = true
        
        try {
          const result = await API.graphql(graphqlOperation(deliverablesBySample, {
            SampleRecordID: this.data.id
          }))
          this.sampleDeliverables = result.data.deliverablesBySample.items.filter(item => item.Status === 'READY')
        } catch (err) {
          console.log('Error fetching sample deliverables:', err)
        }
        
        this.sampleDeliverablesLoading = false
      },

      showSampleDeliverableDetail(item) {
        this.selectedSampleDeliverable = item
        this.isSampleDeliverableDetailDialog = true
      },

      downloadSampleFile: async function() {
        await this.downloadDeliverableFile(this.selectedSampleDeliverable)
      },
    },
    mounted: async function () {
        this.loading = true
        this.applicationid = this.$route.query.id
        let application = await API.graphql(graphqlOperation(getApplication, {id: this.applicationid}))
        console.log("application:", application)
        // 参照依頼情報のアクセスチェック
        // 存在しない依頼情報、他事業所の依頼情報を開いた場合はアクセス不正でエラーにする
        if(!application.data.getApplication) {
          this.isErrorParam = true
          this.ErrorInfo = "notExist"
          this.loading = false
          this.overlayStepper1 = false
          console.log('isErrorParam: ', this.isErrorParam)
          return
        }

        if(this.$store.state.isStaff == false) {
          if(application.data.getApplication.OfficeID != this.$store.state.operatingOffice.OfficeID) {
            this.isErrorParam = true
            this.ErrorInfo = "illegalAccess"
            this.loading = false
            this.overlayStepper1 = false
            console.log('isErrorParam: ', this.isErrorParam)
            return
          }
        }

//        this.AnalizeTypeCategory = this.getApplicationAnalizeTypeCategory(this.quote)
//        this.analizeTypeGroupList = await this.getAnalizeTypeGroupList(this.AnalizeTypeCategory)
//        this.oilTypeCategoryList = await this.getOilTypeCategoryList(this.AnalizeTypeCategory)

        this.application = application.data.getApplication
        this.AnalizeTypeCategory = this.getApplicationAnalizeTypeCategory(this.application)

        // samplesByApplicationクエリを使用してサンプル一覧を取得
        const samplesResult = await API.graphql(graphqlOperation(samplesByApplication, {ApplicationID: this.applicationid}))
        this.samples = samplesResult.data.samplesByApplication.items

        let _delvOffice = await API.graphql(graphqlOperation(officeByKey, {OfficeID: this.application.DelvCompanyID + this.application.DelvOfficeID}))
        this.delvOffice = _delvOffice.data.officeByKey.items[0]

        let _payOffice = await API.graphql(graphqlOperation(officeByKey, {OfficeID: this.application.PayCompanyID + this.application.PayOfficeID}))
        this.payOffice = _payOffice.data.officeByKey.items[0]

        let _delvEmployee = await API.graphql(graphqlOperation(employeeByKey, {EmployeeID: this.application.DelvCompanyID + this.application.DelvOfficeID + this.application.DelvEmployeeID}))
        this.delvEmployee = _delvEmployee.data.employeeByKey.items[0]
/*
        if(!this.delvEmployee) {
          console.log('no delvEmployee: ', this.delvEmployee)
          this.delvEmployee = []
          this.delvEmployee["email"] = ""
        }
*/
        let _payEmployee = await API.graphql(graphqlOperation(employeeByKey, {EmployeeID: this.application.PayCompanyID + this.application.PayOfficeID + this.application.PayEmployeeID}))
        this.payEmployee = _payEmployee.data.employeeByKey.items[0]

        console.log("application.Fee", this.application.Fee)
        console.log("application.Price", this.application.Price)
        if(this.application.Fee) {
          this.AnalizeFee = Number(this.application.Fee)
        }else {
          this.AnalizeFee = Number(this.application.Price)
        }
        if(this.application.hasSurplus == "true") {
          this.SurplusFee = 1800
          this.SurplusCount = 1 //とりあえず1以上であればいいので1
        }
        if(this.application.Discount) {
          this.DiscountInfo = JSON.parse(this.application.Discount)
        }else {
          this.DiscountInfo = {code:"", discount:0 }
        }



//        this.samples.forEach(items => {
        for (const sample of this.samples) {

/*
// デッドロジック
console.log("items.AnalizeTypeName", items.AnalizeTypeName)
console.log("items.AnalizeSetName", items.AnalizeSetName)
          const AnalizeTypeName = this.$store.state.analizeTypeList.filter(item => item.Value  == items.AnalizeType)
          const AnalizeSetByTypes = this.$store.state.analizeSetList.filter(item => item.AnalizeType  == items.AnalizeType)
          if (AnalizeSetByTypes[0]) {
            const AnalizeSetByType = AnalizeSetByTypes[0].AnalizeSets
            const AnalizeSetName = AnalizeSetByType.filter(item => item.Value  == items.AnalizeSet)
            if (AnalizeTypeName[0]) { items.AnalizeTypeName = AnalizeTypeName[0].Text }
            if (AnalizeSetName[0]) { items.AnalizeSetName = AnalizeSetName[0].Text }
          }
*/

          // 分析区分の分析項目一覧取得
          let analizeItemList = await this.getAnalizeItemList(sample.AnalizeType)
          let analizeItemSubList = await this.getAnalizeItemSubList(sample.AnalizeType)
          let AnalizeItems = []
          if(sample.AnalizeItems) {
            try {
              AnalizeItems = JSON.parse(sample.AnalizeItems)
            } catch (e) {
              const replaced = sample.AnalizeItems.replace(/'/g,"\"")
              console.log('replaced', replaced)
              AnalizeItems = JSON.parse(replaced)
            }
/*
            var AnalizeItemNames = []
            for (let analizeItem of analizeItems) {
              let _analiseItemObj = analizeItemList.filter(item => item.Value  == analizeItem)
              let analiseItemObj = _analiseItemObj[0]
              if(analiseItemObj) {
                AnalizeItemNames.push({name: analiseItemObj.Text})
              }else {
                  AnalizeItemNames.push({name: analizeItem})                
              }
            }
            sample.AnalizeItemNames = AnalizeItemNames
*/
          }

          let _AnalizeItemSub = "{}"
          if(sample.AnalizeItemSub != undefined) {
            console.log("sample.AnalizeItemSub:", sample.AnalizeItemSub)
            // ダブルコーテーションなしの{}になるケースがある。
            // ダブルコーテーションなしの場合parseでおかしくなるのではじく。
            // ダブルコーテーションがつく/つかないが不明
            if(sample.AnalizeItemSub != "{}") {
              // 見積で登録したサンプルのAnalizeItemSubは文字列（""で囲まれている）のでparseする
              // 通常（マイ機器、直接）のサンプルはオブジェクト（""で囲まれていない）のでparseしない
              if(sample.AnalizeItemSub.startsWith("\"")) {
                _AnalizeItemSub = JSON.parse(sample.AnalizeItemSub)
                console.log("analizeItemSub(1):", _AnalizeItemSub)
/* 20240405 */
              }else {
//                _AnalizeItemSub = JSON.parse(sample.AnalizeItemSub)
                _AnalizeItemSub = sample.AnalizeItemSub
                console.log("analizeItemSub(2):", _AnalizeItemSub)
              }
/* 20240405 */

              /*
            for (var parentItem of Object.keys(_AnalizeItemSub)) {
                AnalizeItemSub[parentItem] = _AnalizeItemSub[parentItem]
            }
*/
            }
          }
          console.log("mounted AnalizeItemSub:", _AnalizeItemSub)
          sample.AnalizeItemNames = await this.getAnalizeItemNames(AnalizeItems, JSON.parse(_AnalizeItemSub), analizeItemList, analizeItemSubList)
          console.log("AnalizeItemNames:", sample.AnalizeItemNames)

        }

        this.loading = false
        this.overlayStepper1 = false
    },
}
</script>
<style lang="css" scoped>
#row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
</style>